<template>
    <div class="main-wrap device">
        <div class="title">
            <div class="text">
                <span class="str">{{t('main')}}</span>
            </div>
            <div class="name cf">
                <div class="fl">
                    <span class="icon icon-point"></span>
                    <span><tv k="welcome"></tv><a style="padding: 0; margin-left: 5px; text-decoration: underline;" @click="$router.back()">返回</a></span>
                </div>
                <div class="fr">
                    <span>{{date}}</span>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="left">
                <div class="device-info-title">
                    <div class="top-bg"></div>
                    <div class="title-wrap">
                        <span class="icon icon-device-title"></span>
                        <div class="text">
                            <span><tv k="p21"/></span>
                            <span class="sub-text"><tv k="p22"/></span>
                        </div>
                    </div>
                    <div class="top-bg2"></div>
                </div>
                <div class="device-item">
                    <div class="name"><tv k="p23"/></div>
                    <div class="list">
                        <div class="device">
                            <span class="icon icon-device-1"></span>
                            <span class="type"><tv k="p24"/></span>
                            <span class="number"><tv k="p25"/></span>
                        </div>
                        <div class="device">
                            <span class="icon icon-device-2"></span>
                            <span class="type"><tv k="p26"/></span>
                            <span class="number"><tv k="p27" min="1" max="4" suffix="kw" time="500"/></span>
                        </div>
                        <div class="device">
                            <span class="icon icon-device-3"></span>
                            <span class="type"><tv k="p28"/></span>
                            <span class="number"><tv k="p29"/></span>
                        </div>
                    </div>
                </div>
                <div class="line"></div>
                <div class="device-item">
                    <div class="name"><tv k="p210"/></div>
                    <div class="list">
                        <div class="device">
                            <span class="icon icon-device-4"></span>
                            <span class="type"><tv k="p211"/></span>
                            <span class="number"><tv k="p212"/></span>
                        </div>
                        <div class="device">
                            <span class="icon icon-device-5"></span>
                            <span class="type"><tv k="p213"/></span>
                            <span class="number"><tv k="p214"/></span>
                        </div>
                        <div class="device">
                            <span class="icon icon-device-6"></span>
                            <span class="type"><tv k="p215"/></span>
                            <span class="number"><tv k="p216" min="1" max="8" suffix="" time="500"/></span>
                        </div>
                    </div>
                </div>
                <div class="line"></div>
                <div class="device-item">
                    <div class="name"><tv k="p217"/></div>
                    <div class="list">
                        <div class="device">
                            <span class="icon icon-device-7"></span>
                            <span class="type"><tv k="p218"/></span>
                            <span class="number"><tv k="p219" min="1" max="8" suffix="kg" time="500"/></span>
                        </div>
                        <div class="device">
                            <span class="icon icon-device-8"></span>
                            <span class="type"><tv k="p220"/></span>
                            <span class="number"><tv k="p221"/></span>
                        </div>
                        <div class="device">
                            <span class="icon icon-device-9"></span>
                            <span class="type"><tv k="p222"/></span>
                            <span class="number"><tv k="p223" min="1" max="3" suffix="℃" time="5000"/></span>
                        </div>
                    </div>
                </div>
                <div class="line"></div>
                <div class="device-item">
                    <div class="name"><tv k="p224"/></div>
                    <div class="list">
                        <div class="device">
                            <span class="icon icon-device-1"></span>
                            <span class="type"><tv k="p225"/></span>
                            <span class="number"><tv k="p226" min="1" max="8" suffix="%" time="500"/></span>
                        </div>
                        <div class="device">
                            <span class="icon icon-device-2"></span>
                            <span class="type"><tv k="p227"/></span>
                            <span class="number"><tv k="p228"/></span>
                        </div>
                        <div class="device">
                            <span class="icon icon-device-3"></span>
                            <span class="type"><tv k="p229"/></span>
                            <span class="number"><tv k="p230"/></span>
                        </div>
                    </div>
                </div>
                <div class="device-footer"></div>
                <div class="device-info-title" style="margin-bottom: 20px;">
                    <div class="top-bg3"></div>
                    <div class="title-wrap">
                        <span class="icon icon-device-title2"></span>
                        <div class="text">
                            <span><tv k="p231"/></span>
                            <span class="sub-text"><tv k="p232"/></span>
                        </div>
                    </div>
                    <div class="top-bg2"></div>
                </div>
                <div class="group2">
                    <div class="chart-search">
                        <span :class="{'active': countType == 1}" @click="toggleData(1)"><tv k="p233"/></span>
                        <span :class="{'active': countType == 2}" @click="toggleData(2)"><tv k="p234"/></span>
                        <span :class="{'active': countType == 3}" @click="toggleData(3)"><tv k="p235"/></span>
                    </div>
                    <div id="countChart" style="height: 190px"></div>
                </div>
            </div>
            <div class="mid">
                <div class="full-img-wrap">
                    <span class="top"></span>
                    <span class="bottom"></span>
                    <div class="full-title"><tv k="p236"/></div>
                    <div class="view" id="fullViewer">

                    </div>
                </div>
                <div class="mid-info">
                    <div class="item">
                        <div class="info-title">
                            <span class="icon icon-info-title"></span>
                            <div class="text">
                                <span><tv k="p237"/></span>
                                <span class="sub-text"><tv k="p238"/></span>
                            </div>
                            <span class="date"><tv k="p239"/></span>
                        </div>
                        <div class="line"></div>
                        <div class="info-view">
                            <div class="info-1">
                                <div class="pic">
                                    <iv k="pic1"/>
                                </div>
                                <div class="items">
                                    <div class="label">
                                        <span class="key"><tv k="p240"/></span>
                                        <span class="value"><tv k="p241"/></span>
                                    </div>
                                    <div class="label">
                                        <span class="key"><tv k="p242"/></span>
                                        <span class="value"><tv k="p243"/></span>
                                    </div>
                                    <div class="label">
                                        <span class="key"><tv k="p244"/></span>
                                        <span class="value"><tv k="p245"/></span>
                                    </div>
                                    <div class="label">
                                        <span class="key"><tv k="p246"/></span>
                                        <span class="value"><tv k="p247"/></span>
                                    </div>
                                    <div class="label">
                                        <span class="key"><tv k="p248"/> </span>
                                        <span class="value"><tv k="p249"/></span>
                                    </div>
                                </div>
                            </div>
                            <div class="news-text">
                                <marquee><tv k="p250"/></marquee>
                            </div>
                        </div>
                    </div>
                    <div class="sp"></div>
                    <div class="item">
                        <div class="info-title">
                            <span class="icon icon-info-title"></span>
                            <div class="text">
                                <span><tv k="p251"/></span>
                                <span class="sub-text"><tv k="p252"/></span>
                            </div>
                            <span class="date"><tv k="p253"/></span>
                        </div>
                        <div class="line"></div>
                        <div class="info-view">
                            <div class="info-1">
                                <div class="pic">
                                    <iv k="pic2"/>
                                </div>
                                <div class="items">
                                    <div class="label">
                                        <span class="key"><tv k="p254"/></span>
                                        <span class="value"><tv k="p255"/></span>
                                    </div>
                                    <div class="label">
                                        <span class="key"><tv k="p256"/></span>
                                        <span class="value"><tv k="p257"/></span>
                                    </div>
                                    <div class="label">
                                        <span class="key"><tv k="p258"/></span>
                                        <span class="value"><tv k="p259"/></span>
                                    </div>
                                    <div class="label">
                                        <span class="key"><tv k="p260"/></span>
                                        <span class="value"><tv k="p261"/></span>
                                    </div>
                                    <div class="label">
                                        <span class="key"><tv k="p262"/> </span>
                                        <span class="value"><tv k="p263"/></span>
                                    </div>
                                </div>
                            </div>
                            <div class="news-text">
                                <marquee><tv k="p264"/></marquee>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="view-3d" v-loading="loadingModel">
                    <div class="view" ref="modelView" id="modelView"></div>
                </div>
                <div class="models-wrap">
                    <transition-group mode="fade">
                        <game-model v-if="deviceType == 'game'" key="game"></game-model>
                        <player-model v-else-if="deviceType == 'player'" key="player"></player-model>
                        <mic-model v-else-if="deviceType == 'mic'" key="mic"></mic-model>
                        <led-model v-else-if="deviceType == 'led'" key="led"></led-model>
                    </transition-group>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SvgIcon from "../components/SvgIcon";
    import * as echarts from 'echarts';
    import * as THREE from 'three';
    import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"
    import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader"
    import { MTLLoader } from "three/examples/jsm/loaders/MTLLoader"
    import PlayerModel from "../components/PlayerModel";
    import MicModel from "../components/MicModel";
    import GameModel from "../components/GameModel";
    import LedModel from "../components/LedModel";

    export default {
        name: 'Device',
        components: {
            SvgIcon,
            PlayerModel,
            MicModel,
            GameModel,
            LedModel
        },
        data() {
            return {
                run: false,
                countChart: null,
                countType: 1,
                viewer: null,
                deviceType: 'game',
                scene: null,
                camera: null,
                lastObj: null,
                loadingModel: false,
            }
        },
        created() {
            this.run = true;
        },
        destroyed() {
            this.run = false;
        },
        mounted() {

            this.$nextTick(_ => {
                this.countChart = echarts.init(document.querySelector('#countChart'));

                this.init();
                this.initModelView();
                this.initPRA();
            });
        },
        methods: {
            toggleData(type) {
                this.countType = type;
                switch(type) {
                    case 1:
                        this.countChart.setOption(this.getChartsOptions(
                            ['00:00', '03:00', '06:00', '09:00', '11:00', '13:00', '15:00', '18:00', '21:00', '24:00'],
                            [0, 90, 80, 25, 65, 22, 150, 100, 151, 35]
                        ));
                        break;
                    case 2:
                        this.countChart.setOption(this.getChartsOptions(
                            ['00:00', '03:00', '06:00', '09:00', '11:00', '13:00', '15:00', '18:00', '21:00', '24:00'],
                            [0, 16, 210, 25, 295, 166, 250, 340, 253, 205]
                        ));
                        break;
                    case 3:
                        this.countChart.setOption(this.getChartsOptions(
                            ['00:00', '03:00', '06:00', '09:00', '11:00', '13:00', '15:00', '18:00', '21:00', '24:00'],
                            [0, 450, 650, 250, 650, 220, 1500, 1000, 1510, 350]
                        ));
                        break;
                }
            },
            initModelView() {
                let wrap = this.$refs.modelView;
                let self = this;
                let h = wrap.clientHeight, w = wrap.clientWidth;
                var scene = new THREE.Scene();
                scene.background = new THREE.Color( 0x050C2F );

                var camera = new THREE.PerspectiveCamera(75, w / h, 0.1, 1000);

                var renderer = new THREE.WebGLRenderer();
                renderer.setSize(w, h);
                wrap.appendChild(renderer.domElement);

             
                const ambientLight = new THREE.AmbientLight( 0xcccccc, 0.4 );
                scene.add( ambientLight );
                const pointLight = new THREE.PointLight( 0xffffff, 0.8 );
                camera.add( pointLight );
                scene.add( camera );

                function renderModel() {
                    renderer.render(scene,camera);
                    if (self.run) {
                        requestAnimationFrame(renderModel);
                    }
                }

                requestAnimationFrame(renderModel);
   
                this.scene = scene;
                this.camera = camera;
                this.loadModel('投影仪');
            },
            loadModel(name) {
                let path = '/model/';
                let self = this;
                if(self.loadingModel) {
                    this.$message({
                        message: '模型还未加载完毕...',
                        type: 'warning'
                    });
                    return;
                }
                let needMtl = true;
                if(name == '音响') {
                    needMtl = false;
                }
                if(self.lastObj) {
                    self.scene.remove(self.lastObj);
                }
                self.loadingModel = true;
                if(!needMtl) {
                    new OBJLoader()
                        .setPath( path )
                        .load( name + '.obj', function ( object ) {
                            self.loadingModel = false;
                            object.rotation.x += 0.5;
                            object.rotation.y += 0.5;
                            self.scene.add( object );
                            self.lastObj = object;

                            var bBox = new THREE.Box3().setFromObject(self.scene);
                            var height = bBox.size().y;
                            var dist = height / (2 * Math.tan(self.camera.fov * Math.PI / 360));
                            var pos = self.scene.position;

                            self.camera.position.set(pos.x, pos.y, dist * 2.5);
                            self.camera.lookAt(pos);
                        });
                    return;
                }
                var mtlLoader = new MTLLoader()
                    .setPath( path )
                    .load( name + '.mtl', function ( materials ) {
                        materials.preload();
                        new OBJLoader()
                            .setMaterials( materials )
                            .setPath( path )
                            .load( name + '.obj', function ( object ) {
                                self.loadingModel = false;
                                object.rotation.x += 0.5;
                                object.rotation.y += 0.5;
                                self.scene.add( object );
                                self.lastObj = object;

                                var bBox = new THREE.Box3().setFromObject(self.scene);
                                var height = bBox.size().y;
                                var dist = height / (2 * Math.tan(self.camera.fov * Math.PI / 360));
                                var pos = self.scene.position;

                                self.camera.position.set(pos.x, pos.y, dist * 2.5);
                                self.camera.lookAt(pos);
                            });
                    });
            },
            initPRA() {
                let viewer = pannellum.viewer('fullViewer', {
                    panorama: require('@/assets/fullImg/hotel.png'),
                    hotSpotDebug: false,
                    autoLoad: true,
                    "type": "equirectangular",
                    hotSpots: [
                        {
                            "pitch": 14.839690709444758,
                            "yaw": -24.27232724440053,
                            "type": "info",
                            "text": "灯光",
                        },
                        {
                            "pitch": 15.723570549558294,
                            "yaw": 22.964054652078595,
                            "type": "info",
                            "text": "灯光",
                        },
                        {
                            "pitch": -0.9704745822509092,
                            "yaw": -0.7466094536220116,
                            "type": "info",
                            "text": "舞台大屏",
                            clickHandlerArgs: 'led',
                            clickHandlerFunc: this.callBack,
                        },
                        {
                            "pitch": 1.938792829933043,
                            "yaw": -20.5438731582476,
                            "type": "info",
                            "text": "音响",
                            clickHandlerArgs: 'sound',
                            clickHandlerFunc: this.callBack,
                        },
                        {
                            "pitch": 2.209051455026641,
                            "yaw": 19.69165776044205,
                            "type": "info",
                            "text": "音响",
                            clickHandlerArgs: 'sound',
                            clickHandlerFunc: this.callBack,
                        },
                        {
                            "pitch": -1.7389801529841735,
                            "yaw": 12.675076173543998,
                            "type": "info",
                            "text": "调音台",
                            clickHandlerArgs: 'mixer',
                            clickHandlerFunc: this.callBack,
                        },
                        {
                            "pitch": 0.9337559386857207,
                            "yaw": -151.34235783136685,
                            "type": "info",
                            "text": "电柜",
                            clickHandlerArgs: 'power',
                            clickHandlerFunc: this.callBack,
                        },
                        {
                            "pitch": 21.97069250898619,
                            "yaw": -140.8355204795765,
                            "type": "info",
                            "text": "投影仪",
                            clickHandlerArgs: 'projector',
                            clickHandlerFunc: this.callBack,
                        },
                        {
                            "pitch": 21.98767676522187,
                            "yaw": 139.58364433619482,
                            "type": "info",
                            "text": "投影仪",
                            clickHandlerArgs: 'projector',
                            clickHandlerFunc: this.callBack,
                        },
                    ],
                });
                this.viewer = viewer;
                window.viewer = viewer;
            },
            init() {
                this.countChart.setOption(this.getChartsOptions(
                    ['00:00', '03:00', '06:00', '09:00', '11:00', '13:00', '15:00', '18:00', '21:00', '24:00'],
                    [0, 40, 80, 25, 65, 22, 150, 100, 151, 35]
                ));
            },
            callBack(e, type) {
                switch(type) {
                    case 'led':
                        this.deviceType = type;
                        this.loadModel('led_屏幕');
                        break;
                    case 'power':
                        this.loadModel('电柜');
                        break;
                    case 'projector':
                        this.loadModel('投影仪');
                        break;
                    case 'sound':
                        this.deviceType = 'player';
                        this.loadModel('音响');
                        break;
                    case 'mixer':
                        this.deviceType = 'player';
                        this.loadModel('调音台');
                        break;

                }
            },
            getChartsOptions(x, data) {

                return {
                    tooltip: {
                        trigger: 'axis'
                    },
                    title: {
                        text: '使用时长（小时）',
                        left: 7,
                        top: 7,
                        textStyle: {
                            fontSize: 12,
                            color: '#ffffff',
                        }
                    },
                    grid: {
                        left: 30,
                        right: 20,
                        bottom: 30,
                        top: 40,
                    },
                    xAxis: {
                        type: 'category',
                        data: x,
                        axisLine: {
                            lineStyle: {
                                color: '#ffffff',//坐标轴颜色
                            }
                        },
                    },
                    yAxis: {
                        type: 'value',
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: '#0A2445',//分割线颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#ffffff',//坐标轴颜色
                            }
                        },
                    },
                    series: [{
                        /*lineStyle: {
                           color: colors[0]
                        },*/
                        data: data,//;
                        type: 'line',
                        itemStyle: {
                            normal: {
                                color: '#44d7b6',//点颜色
                                lineStyle: {
                                    color: '#32C5FF',//线颜色
                                }
                            }
                        },
                        markPoint: {
                            itemStyle: {}
                        }
                    }]
                };
            },
        }
    }
</script>
<style lang="less">
    .device {
        .device-info-title {
            display: flex;
            flex-direction: column;
            margin-bottom: 40px;
            position: relative;

            .top-bg {
                background: url(../assets/img/device-info-title-bg.png) no-repeat center center;
                background-size: 100% 100%;
                height: 4px;
            }

            .top-bg2 {

                background: url(../assets/img/device-info-title-bg2.png) no-repeat center center;
                background-size: 100% 100%;
                height: 4px;
            }

            .top-bg3 {
                position: absolute;
                top: 0px;
                right: 0;
                height: 9px;
                width: 9px;
                background-color: #32c5ff;
            }

            .title-wrap {
                padding: 6px 0 8px;
                display: flex;
                flex-direction: row;

                .icon-device-title, .icon-device-title2 {
                    width: 48px;
                    height: 48px;
                }

                .text {
                    padding-left: 10px;
                    display: flex;
                    flex-direction: column;
                    font-size: 20px;
                    letter-spacing: 0px;
                    color: #ffffff;
                    justify-content: center;

                    .sub-text {
                        font-size: 12px;
                        letter-spacing: 0px;
                        color: #999999;
                    }
                }
            }
        }

        .device-item {
            display: flex;
            flex-direction: row;

            .name {
                border: 1px solid #323232;
                font-size: 18px;
                letter-spacing: 0px;
                color: #32c5ff;
                position: relative;
                width: 2.7em;
                padding: 8px 15px;

                &:after, &:before {
                    content: " ";
                    position: absolute;
                    border-color: #32C5FF;
                    border-style: solid;
                    border-width: 0;
                    height: 8px;
                    width: 8px;
                }

                &:after {
                    border-top-width: 1px;
                    border-left-width: 1px;
                    top: -1px;
                    left: -1px;
                }
                &:before {
                    border-bottom-width: 1px;
                    border-right-width: 1px;
                    bottom: -1px;
                    right: -1px;
                }
            }

            .list {
                display: flex;
                flex-direction: row;
                flex-grow: 1;
                justify-content: space-between;

                .device {
                    display: flex;
                    flex-direction: column;
                    text-align: center;
                    justify-content: space-between;

                    &:first-child {
                        margin-left: 22px;
                    }

                    & + .device {
                        border-left: 2px solid #32c5ff;
                        padding-left: 22px;
                    }

                    .icon {
                        width: 60px;
                        height: 60px;
                    }

                    .type {
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #ffffff;
                    }

                    .number {
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #32c5ff;
                    }
                }
            }
        }

        .device-footer {
            background: url(../assets/img/device-footer.png) no-repeat center center;
            height: 27px;
            background-size: 100% 100%;
            margin-top: 20px;
            margin-bottom: 30px;
        }

        .line {
            height: 8px;
            background-color: #171f49;
            margin-top: 16px;
            margin-bottom: 19px;
        }

        .view-3d {
            position: relative;
            padding: 15px;

            .view {
                height: 500px;
            }

            &:before {
                content: " ";
                background: url(../assets/img/3d-view-bg1.png) no-repeat center center;
                position: absolute;
                background-size: 100% 100%;
                top: 0;
                left: 0;
                right: 0;
                height: 40px;
            }
            &:after {
                content: " ";
                background: url(../assets/img/3d-view-bg2.png) no-repeat center center;
                position: absolute;
                background-size: 100% 100%;
                bottom: 0;
                left: 0;
                right: 0;
                height: 40px;
            }
        }

        .mid {
            padding: 20px 15px;
        }

        .full-img-wrap {
            height: 690px;
            border: solid 1px rgba(50, 197, 255, 0.27);
            position: relative;
            display: flex;
            padding: 0 10px 10px;
            flex-direction: column;

            .full-title {
                text-align: center;
                font-size: 27px;
                letter-spacing: 0px;
                color: #ffffff;
                padding: 16px;
            }

            .top, .bottom {
                display: inline-block;

                &:before, &:after {
                    height: 22px;
                    width: 22px;
                    position: absolute;
                    content: " ";
                    border-color: #32C5FF;
                    border-style: solid;
                    border-width: 0;
                }
            }

            .top {
                &:before {
                    top: -1px;
                    left: -1px;
                    border-top-width: 2px;
                    border-left-width: 2px;
                }

                &:after {
                    top: -1px;
                    right: -1px;
                    border-top-width: 2px;
                    border-right-width: 2px;
                }
            }

            .bottom {

                &:before {
                    bottom: -1px;
                    left: -1px;
                    border-bottom-width: 2px;
                    border-left-width: 2px;
                }

                &:after {
                    bottom: -1px;
                    right: -1px;
                    border-bottom-width: 2px;
                    border-right-width: 2px;
                }
            }

            .view {
                flex-grow: 1;
            }
        }

        .mid-info {
            display: flex;
            margin-top: 10px;

            .item {
                flex-grow: 1;

                .info-title {
                    display: flex;
                    align-content: center;
                    padding: 13px;
                    border: 1px solid rgba(50, 197, 255, 0.48);
                    border-radius: 8px;

                    .icon {
                        height: 34px;
                        width: 34px;
                    }

                    .text {
                        padding: 0 10px;
                        flex-grow: 1;
                        font-size: 18px;
                        letter-spacing: 0px;
                        color: #32c5ff;
                        display: flex;
                        flex-direction: column;

                        .sub-text {
                            font-size: 12px;
                            letter-spacing: 0px;
                            color: #999999;
                        }
                    }

                    .date {
                        padding-left: 10px;
                        height: 2.4em;
                        line-height: 2.4em;
                        flex-shrink: 0;
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #32c5ff;
                        width: 150px;
                        background-color: #033448;
                    }
                }

                .line {
                    background: url(../assets/img/info-line-bg.png) no-repeat center center;
                    background-size: 100% 100%;
                    height: 5px;
                }

                .info-view {
                    border-radius: 8px;
                    border: 1px dashed rgba(50, 197, 255, 0.47);
                    padding: 10px;

                    .info-1 {
                        display: flex;
                        flex-direction: row;

                        .pic {
                            height: 104px;
                            width: 87px;
                            padding: 8px;
                            flex-shrink: 0;
                            background: url(../assets/img/info-pic-bg.png) no-repeat center center;
                            background-size: 100% 100%;

                            img {
                                border: 1px solid #32c5ff;
                                height: 100%;
                                width: 100%;
                            }
                            margin-right: 10px;
                        }

                        .items {
                            display: flex;
                            flex-wrap: wrap;

                            .label {
                                height: 48px;
                                display: flex;
                                width: 50%;
                                align-items: center;

                                .key {
                                    font-size: 16px;
                                    letter-spacing: 0px;
                                    color: #ffffff;
                                    display: inline-block;
                                    min-width: 85px;
                                }

                                .value {
                                    font-size: 17px;
                                    letter-spacing: 0px;
                                    color: #32c5ff;
                                }
                            }
                        }
                    }
                }

                .news-text {
                    position: relative;
                    margin-left: 10px;
                    padding: 10px 10px;
                    border-bottom: 2px solid #152c4a;
                    height: 40px;
                    line-heigh: 30px;

                    &:before {
                        content: " ";
                        background: url(../assets/img/news-bg-1.png) no-repeat center center;
                        background-size: 100% 100%;
                        width: 10px;
                        height: 30px;
                        position: absolute;
                        left: -10px;
                        top: 10px;
                    }
                }
            }

            .sp {
                width: 38px;
            }
        }

        .models-wrap {
            margin-top: 30px;
        }
    }
</style>
